export const MAX_REPORT_DATE_RANGE_MONTHS = 6

export const getLocalDateString = (date = new Date()) => {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')

  return `${year}-${month}-${day}`
}

const toDate = (value: string) => new Date(`${value}T00:00:00`)

export const getMaxAllowedDateString = () => getLocalDateString()

export const getMinAllowedDateString = () => {
  const date = new Date()
  date.setMonth(date.getMonth() - MAX_REPORT_DATE_RANGE_MONTHS)

  return getLocalDateString(date)
}

export const isDateWithinAllowedRange = (value: string) => {
  const time = toDate(value).getTime()

  return (
    time >= toDate(getMinAllowedDateString()).getTime() &&
    time <= toDate(getMaxAllowedDateString()).getTime()
  )
}

export const clampDateString = (value: string) => {
  const min = getMinAllowedDateString()
  const max = getMaxAllowedDateString()

  if (toDate(value).getTime() < toDate(min).getTime()) {
    return min
  }

  if (toDate(value).getTime() > toDate(max).getTime()) {
    return max
  }

  return value
}

export const clampDateRange = (start: string, end: string) => {
  let clampedStart = clampDateString(start)
  let clampedEnd = clampDateString(end)

  if (toDate(clampedStart).getTime() > toDate(clampedEnd).getTime()) {
    clampedEnd = clampedStart
  }

  return { start: clampedStart, end: clampedEnd }
}

export const canNavigateToMonth = (month: Date, direction: -1 | 1) => {
  const next = new Date(month)
  next.setMonth(month.getMonth() + direction)

  const min = toDate(getMinAllowedDateString())
  const max = toDate(getMaxAllowedDateString())
  const lastDayOfMonth = new Date(next.getFullYear(), next.getMonth() + 1, 0)
  const firstDayOfMonth = new Date(next.getFullYear(), next.getMonth(), 1)

  if (direction < 0) {
    return lastDayOfMonth.getTime() >= min.getTime()
  }

  return firstDayOfMonth.getTime() <= max.getTime()
}
